export const translations = {
  fr: {
    nav: { home: "Accueil", work: "Work", learn: "Learn", create: "Create", money: "Money", community: "Community", dashboard: "Tableau de bord", documents: "Documents", settings: "Paramètres", admin: "Administration", pricing: "Tarifs", logout: "Déconnexion" },
    common: { save: "Enregistrer", cancel: "Annuler", delete: "Supprimer", create: "Créer", edit: "Modifier", generate: "Générer", loading: "Chargement…", back: "Retour", search: "Rechercher", credits: "crédits", email: "Email", password: "Mot de passe", required: "Ce champ est requis", success: "Succès", error: "Une erreur est survenue", confirm: "Confirmer", close: "Fermer", copy: "Copier", copied: "Copié", export: "Exporter", preview: "Aperçu", none: "Aucun", all: "Tout" },
    landing: {
      badge: "Plateforme personnelle mondiale",
      heroTitle: "Une seule plateforme pour votre vie numérique",
      heroSub: "URLIFA réunit votre carrière, vos apprentissages, vos créations, vos finances et votre communauté — adapté à votre pays et votre langue.",
      universes: "Work • Learn • Create • Money • Community",
      getStarted: "Commencer gratuitement", login: "Se connecter", seeHow: "Comment ça marche",
      valueTitle: "Tout ce dont vous avez besoin, au même endroit",
      valueSub: "Pas seulement une plateforme IA. Un véritable espace personnel pour avancer, jour après jour.",
      howTitle: "Comment fonctionne URLIFA", 
      how1: "Créez votre compte", how1d: "Inscription en quelques secondes.",
      how2: "Configurez votre pays", how2d: "Langue, devise et objectifs adaptés localement.",
      how3: "Utilisez vos univers", how3d: "Work, Learn, Create, Money et Community réunis.",
      pricingTitle: "Des offres simples et transparentes",
      pricingSub: "Commencez gratuitement. Évoluez quand vous en avez besoin.",
      ctaTitle: "Prêt à démarrer avec URLIFA ?", ctaSub: "Rejoignez une communauté internationale et prenez le contrôle de votre vie numérique.",
      footer: "Plateforme personnelle numérique tout-en-un",
    },
    universes: {
      work: "Carrière & productivité", workDesc: "CV, lettres de motivation et traduction professionnelle.",
      learn: "Apprentissage", learnDesc: "Quiz, flashcards et résumés générés pour vous.",
      create: "Création", createDesc: "Rédigez, reformulez et créez du contenu.",
      money: "Finances personnelles", moneyDesc: "Budget, dépenses récurrentes et coach crédit localisé.",
      community: "Communauté", communityDesc: "Forum, groupes et échanges internationaux.",
    },
    auth: {
      loginTitle: "Bon retour", loginSub: "Connectez-vous à votre compte URLIFA",
      registerTitle: "Créer un compte", registerSub: "Rejoignez URLIFA gratuitement",
      fullName: "Nom complet", noAccount: "Pas encore de compte ?", haveAccount: "Déjà un compte ?",
      forgot: "Mot de passe oublié ?", signIn: "Se connecter", signUp: "S'inscrire",
      forgotTitle: "Mot de passe oublié", forgotSub: "Recevez un lien de réinitialisation par email",
      sendLink: "Envoyer le lien", resetTitle: "Nouveau mot de passe", resetSub: "Choisissez un nouveau mot de passe",
      newPassword: "Nouveau mot de passe", reset: "Réinitialiser", checkEmail: "Vérifiez votre boîte mail.",
      verifyTitle: "Vérification de l'email", verifying: "Vérification en cours…", verified: "Email vérifié ✓", verifyFail: "Lien invalide ou expiré.",
      backToLogin: "Retour à la connexion",
    },
    onboarding: {
      title: "Bienvenue sur URLIFA", subtitle: "Configurons votre expérience en quelques étapes",
      step: "Étape", of: "sur",
      language: "Langue", country: "Pays", currency: "Devise", goals: "Vos objectifs",
      goalsSub: "Sélectionnez ce qui vous intéresse (plusieurs choix possibles)",
      finish: "Terminer", next: "Suivant",
      goalOptions: { job: "Trouver un emploi", cv: "Améliorer mon CV", learn: "Apprendre", content: "Créer du contenu", finance: "Organiser mes finances", community: "Rejoindre une communauté" },
    },
    dashboard: {
      welcome: "Bonjour", subtitle: "Voici votre espace URLIFA",
      quickAccess: "Accès rapide", recentActivity: "Activité récente", noActivity: "Aucune activité récente. Commencez à explorer vos univers !",
      yourPlan: "Votre plan", creditsLeft: "crédits disponibles", upgrade: "Améliorer", open: "Ouvrir",
    },
    work: {
      title: "URLIFA Work", subtitle: "Boostez votre carrière",
      cv: "CV", letters: "Lettres", translate: "Traduction", jobAnalysis: "Analyse d'offre",
      myCVs: "Mes CV", newCV: "Nouveau CV", cvTitle: "Titre du CV", noCVs: "Aucun CV pour le moment.",
      myLetters: "Mes lettres", newLetter: "Nouvelle lettre", jobTitle: "Poste", company: "Entreprise",
      jobDescription: "Description du poste", context: "Contexte / informations complémentaires", generateLetter: "Générer la lettre",
      sourceText: "Texte à traduire", from: "De", to: "Vers", translationContext: "Contexte", translation: "Traduction",
      history: "Historique", noTranslations: "Aucune traduction enregistrée.",
      analyzeJob: "Analyser une offre", pasteJob: "Collez ici la description de l'offre d'emploi…", analysisResult: "Résultat de l'analyse",
    },
    cv: {
      identity: "Identité", summary: "Résumé professionnel", experiences: "Expériences", education: "Formation",
      skills: "Compétences", languages: "Langues", certifications: "Certifications",
      exportPdf: "Exporter en PDF", aiAssist: "Améliorer avec l'IA", addExperience: "Ajouter une expérience",
      addEducation: "Ajouter une formation", role: "Poste", description: "Description", start: "Début", end: "Fin",
      degree: "Diplôme", school: "Établissement", skillPlaceholder: "Ajouter une compétence (Entrée)", saved: "CV enregistré",
    },
    learn: {
      title: "URLIFA Learn", subtitle: "Apprenez à votre rythme",
      quiz: "Quiz", flashcards: "Flashcards", summaries: "Résumés", spaces: "Espaces",
      sourceContent: "Contenu source", numQuestions: "Nombre de questions", generateQuiz: "Générer le quiz",
      generateFlashcards: "Générer les flashcards", generateSummary: "Générer le résumé",
      startQuiz: "Commencer", question: "Question", score: "Score", finish: "Terminer le quiz", retry: "Recommencer",
      showAnswer: "Voir la réponse", noQuizzes: "Aucun quiz. Générez-en un !",
      pasteContent: "Collez ou saisissez le contenu à étudier…",
    },
    create: {
      title: "URLIFA Create", subtitle: "Créez et améliorez votre contenu",
      write: "Rédiger", rewrite: "Reformuler", correct: "Corriger", improve: "Améliorer",
      summary: "Résumer", translate: "Traduire", ideas: "Idées", social: "Réseaux sociaux", marketing: "Marketing",
      prompt: "Votre texte ou consigne", result: "Résultat", myCreations: "Mes créations", noCreations: "Aucune création.",
    },
    documents: {
      title: "Documents", subtitle: "Importez et analysez vos documents",
      upload: "Importer un document", myDocuments: "Mes documents", noDocuments: "Aucun document importé.",
      summarize: "Résumer", analyze: "Analyser", translateDoc: "Traduire", askQuestion: "Poser une question",
      question: "Votre question sur le document", dropHint: "PDF, DOCX ou TXT (max 10 Mo)", analyses: "Analyses",
    },
    community: {
      title: "URLIFA Community", subtitle: "Échangez avec la communauté internationale",
      feed: "Fil", groups: "Groupes", newPost: "Nouvelle publication", whatsOnMind: "Quoi de neuf ?",
      publish: "Publier", comments: "Commentaires", addComment: "Ajouter un commentaire…", like: "J'aime",
      reply: "Répondre", report: "Signaler", join: "Rejoindre", leave: "Quitter", members: "membres",
      newGroup: "Nouveau groupe", groupName: "Nom du groupe", visibility: "Visibilité", public: "Public", private: "Privé",
      noPosts: "Aucune publication pour le moment. Soyez le premier !", reportReason: "Motif du signalement", reported: "Signalé. Merci.",
      privateGroup: "Groupe privé", pending: "En attente d'approbation",
    },
    money: {
      title: "URLIFA Money", subtitle: "Organisez vos finances — adapté à votre pays",
      budget: "Budget", recurring: "Dépenses récurrentes", creditCoach: "Coach crédit",
      income: "Revenus", expenses: "Dépenses", balance: "Solde estimé", newBudget: "Nouveau budget",
      addIncome: "Ajouter un revenu", addExpense: "Ajouter une dépense", label: "Libellé", amount: "Montant", category: "Catégorie",
      addRecurring: "Ajouter une dépense récurrente", frequency: "Fréquence", nextDue: "Prochaine échéance",
      monthly: "Mensuel", yearly: "Annuel", weekly: "Hebdomadaire",
      creditSystem: "Système de crédit", coachDisabled: "Le coach crédit n'est pas encore disponible pour votre pays.",
      tips: "Conseils", noBudgets: "Aucun budget. Créez-en un pour commencer.",
    },
    settings: {
      title: "Paramètres", profile: "Profil", account: "Compte", preferences: "Préférences",
      professionalTitle: "Titre professionnel", bio: "Biographie", phone: "Téléphone",
      language: "Langue", country: "Pays", currency: "Devise", theme: "Thème", light: "Clair", dark: "Sombre",
      changePassword: "Changer le mot de passe", currentPassword: "Mot de passe actuel", newPassword: "Nouveau mot de passe",
      emailVerified: "Email vérifié", emailNotVerified: "Email non vérifié", profileUpdated: "Profil mis à jour",
    },
    pricing: { title: "Tarifs", subtitle: "Choisissez le plan adapté à vos besoins", month: "/mois", currentPlan: "Plan actuel", choose: "Choisir", creditsPacks: "Packs de crédits", buy: "Acheter", perMonth: "crédits / mois", comingSoon: "Bientôt disponible", mockNote: "Les abonnements payants et les packs de crédits seront disponibles prochainement." },
    admin: {
      title: "Administration", stats: "Statistiques", users: "Utilisateurs", countries: "Pays", plans: "Plans",
      reports: "Signalements", audit: "Journaux d'audit",
      totalUsers: "Utilisateurs", newUsers: "Nouveaux (30j)", activeUsers: "Actifs (30j)", paidSubs: "Abonnements payants",
      conversion: "Conversion", aiRequests: "Requêtes IA", creditsUsed: "Crédits utilisés", openReports: "Signalements ouverts",
      role: "Rôle", status: "Statut", active: "Actif", suspended: "Suspendu", suspend: "Suspendre", activate: "Activer",
      resolve: "Traiter", removeContent: "Supprimer le contenu", usageByModule: "Utilisation par module",
    },
  },
  en: {
    nav: { home: "Home", work: "Work", learn: "Learn", create: "Create", money: "Money", community: "Community", dashboard: "Dashboard", documents: "Documents", settings: "Settings", admin: "Admin", pricing: "Pricing", logout: "Log out" },
    common: { save: "Save", cancel: "Cancel", delete: "Delete", create: "Create", edit: "Edit", generate: "Generate", loading: "Loading…", back: "Back", search: "Search", credits: "credits", email: "Email", password: "Password", required: "This field is required", success: "Success", error: "Something went wrong", confirm: "Confirm", close: "Close", copy: "Copy", copied: "Copied", export: "Export", preview: "Preview", none: "None", all: "All" },
    landing: {
      badge: "Global personal platform",
      heroTitle: "One platform for your entire digital life",
      heroSub: "URLIFA brings together your career, learning, creations, finances and community — adapted to your country and language.",
      universes: "Work • Learn • Create • Money • Community",
      getStarted: "Start for free", login: "Log in", seeHow: "How it works",
      valueTitle: "Everything you need, in one place",
      valueSub: "Not just an AI platform. A real personal space to move forward, day after day.",
      howTitle: "How URLIFA works",
      how1: "Create your account", how1d: "Sign up in seconds.",
      how2: "Set your country", how2d: "Language, currency and goals adapted locally.",
      how3: "Use your universes", how3d: "Work, Learn, Create, Money and Community together.",
      pricingTitle: "Simple, transparent plans", pricingSub: "Start free. Upgrade when you need to.",
      ctaTitle: "Ready to get started with URLIFA?", ctaSub: "Join an international community and take control of your digital life.",
      footer: "All-in-one personal digital platform",
    },
    universes: {
      work: "Career & productivity", workDesc: "Résumés, cover letters and professional translation.",
      learn: "Learning", learnDesc: "Quizzes, flashcards and summaries generated for you.",
      create: "Creation", createDesc: "Write, rewrite and create content.",
      money: "Personal finance", moneyDesc: "Budget, recurring expenses and localized credit coach.",
      community: "Community", communityDesc: "Forum, groups and international exchanges.",
    },
    auth: {
      loginTitle: "Welcome back", loginSub: "Log in to your URLIFA account",
      registerTitle: "Create an account", registerSub: "Join URLIFA for free",
      fullName: "Full name", noAccount: "No account yet?", haveAccount: "Already have an account?",
      forgot: "Forgot password?", signIn: "Log in", signUp: "Sign up",
      forgotTitle: "Forgot password", forgotSub: "Get a reset link by email",
      sendLink: "Send link", resetTitle: "New password", resetSub: "Choose a new password",
      newPassword: "New password", reset: "Reset", checkEmail: "Check your inbox.",
      verifyTitle: "Email verification", verifying: "Verifying…", verified: "Email verified ✓", verifyFail: "Invalid or expired link.",
      backToLogin: "Back to login",
    },
    onboarding: {
      title: "Welcome to URLIFA", subtitle: "Let's set up your experience in a few steps",
      step: "Step", of: "of",
      language: "Language", country: "Country", currency: "Currency", goals: "Your goals",
      goalsSub: "Select what interests you (multiple choices possible)",
      finish: "Finish", next: "Next",
      goalOptions: { job: "Find a job", cv: "Improve my résumé", learn: "Learn", content: "Create content", finance: "Organize my finances", community: "Join a community" },
    },
    dashboard: {
      welcome: "Hello", subtitle: "Here is your URLIFA space",
      quickAccess: "Quick access", recentActivity: "Recent activity", noActivity: "No recent activity. Start exploring your universes!",
      yourPlan: "Your plan", creditsLeft: "credits available", upgrade: "Upgrade", open: "Open",
    },
    work: {
      title: "URLIFA Work", subtitle: "Boost your career",
      cv: "Résumé", letters: "Letters", translate: "Translation", jobAnalysis: "Job analysis",
      myCVs: "My résumés", newCV: "New résumé", cvTitle: "Résumé title", noCVs: "No résumé yet.",
      myLetters: "My letters", newLetter: "New letter", jobTitle: "Job title", company: "Company",
      jobDescription: "Job description", context: "Context / additional info", generateLetter: "Generate letter",
      sourceText: "Text to translate", from: "From", to: "To", translationContext: "Context", translation: "Translation",
      history: "History", noTranslations: "No saved translations.",
      analyzeJob: "Analyze a job offer", pasteJob: "Paste the job description here…", analysisResult: "Analysis result",
    },
    cv: {
      identity: "Identity", summary: "Professional summary", experiences: "Experience", education: "Education",
      skills: "Skills", languages: "Languages", certifications: "Certifications",
      exportPdf: "Export to PDF", aiAssist: "Enhance with AI", addExperience: "Add experience",
      addEducation: "Add education", role: "Role", description: "Description", start: "Start", end: "End",
      degree: "Degree", school: "School", skillPlaceholder: "Add a skill (Enter)", saved: "Résumé saved",
    },
    learn: {
      title: "URLIFA Learn", subtitle: "Learn at your own pace",
      quiz: "Quiz", flashcards: "Flashcards", summaries: "Summaries", spaces: "Spaces",
      sourceContent: "Source content", numQuestions: "Number of questions", generateQuiz: "Generate quiz",
      generateFlashcards: "Generate flashcards", generateSummary: "Generate summary",
      startQuiz: "Start", question: "Question", score: "Score", finish: "Finish quiz", retry: "Retry",
      showAnswer: "Show answer", noQuizzes: "No quiz yet. Generate one!",
      pasteContent: "Paste or type the content to study…",
    },
    create: {
      title: "URLIFA Create", subtitle: "Create and improve your content",
      write: "Write", rewrite: "Rewrite", correct: "Correct", improve: "Improve",
      summary: "Summarize", translate: "Translate", ideas: "Ideas", social: "Social", marketing: "Marketing",
      prompt: "Your text or instruction", result: "Result", myCreations: "My creations", noCreations: "No creation yet.",
    },
    documents: {
      title: "Documents", subtitle: "Upload and analyze your documents",
      upload: "Upload a document", myDocuments: "My documents", noDocuments: "No document uploaded.",
      summarize: "Summarize", analyze: "Analyze", translateDoc: "Translate", askQuestion: "Ask a question",
      question: "Your question about the document", dropHint: "PDF, DOCX or TXT (max 10 MB)", analyses: "Analyses",
    },
    community: {
      title: "URLIFA Community", subtitle: "Connect with the international community",
      feed: "Feed", groups: "Groups", newPost: "New post", whatsOnMind: "What's on your mind?",
      publish: "Publish", comments: "Comments", addComment: "Add a comment…", like: "Like",
      reply: "Reply", report: "Report", join: "Join", leave: "Leave", members: "members",
      newGroup: "New group", groupName: "Group name", visibility: "Visibility", public: "Public", private: "Private",
      noPosts: "No posts yet. Be the first!", reportReason: "Report reason", reported: "Reported. Thank you.",
      privateGroup: "Private group", pending: "Pending approval",
    },
    money: {
      title: "URLIFA Money", subtitle: "Organize your finances — adapted to your country",
      budget: "Budget", recurring: "Recurring expenses", creditCoach: "Credit coach",
      income: "Income", expenses: "Expenses", balance: "Estimated balance", newBudget: "New budget",
      addIncome: "Add income", addExpense: "Add expense", label: "Label", amount: "Amount", category: "Category",
      addRecurring: "Add recurring expense", frequency: "Frequency", nextDue: "Next due",
      monthly: "Monthly", yearly: "Yearly", weekly: "Weekly",
      creditSystem: "Credit system", coachDisabled: "The credit coach is not yet available for your country.",
      tips: "Tips", noBudgets: "No budget. Create one to start.",
    },
    settings: {
      title: "Settings", profile: "Profile", account: "Account", preferences: "Preferences",
      professionalTitle: "Professional title", bio: "Bio", phone: "Phone",
      language: "Language", country: "Country", currency: "Currency", theme: "Theme", light: "Light", dark: "Dark",
      changePassword: "Change password", currentPassword: "Current password", newPassword: "New password",
      emailVerified: "Email verified", emailNotVerified: "Email not verified", profileUpdated: "Profile updated",
    },
    pricing: { title: "Pricing", subtitle: "Choose the plan that fits your needs", month: "/mo", currentPlan: "Current plan", choose: "Choose", creditsPacks: "Credit packs", buy: "Buy", perMonth: "credits / month", comingSoon: "Coming soon", mockNote: "Paid plans and credit packs will be available soon." },
    admin: {
      title: "Admin", stats: "Statistics", users: "Users", countries: "Countries", plans: "Plans",
      reports: "Reports", audit: "Audit logs",
      totalUsers: "Users", newUsers: "New (30d)", activeUsers: "Active (30d)", paidSubs: "Paid subscriptions",
      conversion: "Conversion", aiRequests: "AI requests", creditsUsed: "Credits used", openReports: "Open reports",
      role: "Role", status: "Status", active: "Active", suspended: "Suspended", suspend: "Suspend", activate: "Activate",
      resolve: "Resolve", removeContent: "Remove content", usageByModule: "Usage by module",
    },
  },
};
